module.exports = __webpack_public_path__ + "img/first-en-m.526abd64.png";